import React from 'react';
import {SidebarContainer, SidebarTitle, LogoList, LogoItem, LogoImage} from './SidebarSponsorStyles';

const SidebarSponsor = () => {
    const sponsors = [
        { name: 'Nico', logo: 'https://rossomotori.it/wp-content/uploads/2025/01/Nico-Logo.ai_.jpg', link: 'https://www.instagram.com/ndmracing/' },
        { name: 'DodiciCilindri', logo: 'https://rossomotori.it/wp-content/uploads/2026/05/dodicicilindri_x_rossomotori_dodicicilindri_black-1-scaled.png', link: 'https://www.dodicicilindri.com' },
    ];

    return (
        <SidebarContainer>
            <h3>Partner</h3>
            <LogoList>
                {sponsors.map((sponsor, index) => (
                    <LogoItem key={index}>
                        <a href={sponsor.link} target="_blank" rel="noopener noreferrer">
                            <LogoImage src={sponsor.logo} alt={sponsor.name} />
                        </a>
                    </LogoItem>
                ))}
            </LogoList>
        </SidebarContainer>
    );
};

export default SidebarSponsor;
